import {DetailsHeader} from '@/components/commons/details-header/DetailsHeader'
import {Badge} from '@/components/ui/badge/Badge'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {formatLocaleDate} from '@/dayjs'
import {PatientDetailsOptions} from '@/features/patients/components/patient-details-options/PatientDetailsOptions'
import {PatientExtended} from '@/features/patients/types'
import {useTranslation} from '@/translations/i18n'

export const PatientDetailsHeader = ({patient}: {patient: PatientExtended}) => {
    const {t} = useTranslation()

    return (
        <DetailsHeader
            patientId={patient.id}
            endSlot={<PatientDetailsOptions patient={patient} />}
            subtitle={t('patients:created_at', {date: formatLocaleDate(patient.createdAt, 'DD/MM/YYYY')})}
            title={
                <Flexbox gap={4} align="center">
                    {patient.fullName}
                    {patient.status == 'deceased' && (
                        <Badge size="lg" variant="orange" shape="rectangle">
                            {t('commons:passed_away')}
                        </Badge>
                    )}
                </Flexbox>
            }
        />
    )
}
